import React from 'react';
import { motion } from 'framer-motion';
export function WhoWeServe() {
  const columns = [['Gold Seal', 'DLLR Licensing', 'DHMH Licensing', 'Adult Dependent Care', 'Adoption', 'Armored Car Drivers', 'Pharmacy', 'Physicians', 'Hospitals', 'Security Companies'], ['Lottery Operators', 'Special Police', 'Private Detectives', 'Pawn Brokers', 'School Volunteers', 'Gaming (Casinos)', 'Child and Elder Care', 'Transportation', 'Immigration', 'CDL Drivers'], ['Medical Technicians', 'Nurses', 'Social Workers/Therapists', 'Family Caregivers', 'Foster Care', 'Security Guards', 'Precious Metal Dealers', 'Liquor Licenses', 'Horse-Racing Operators', 'And More...']];
  return <section id="who-we-serve" className="py-24 bg-[#0A0F1E]" aria-labelledby="who-we-serve-heading" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="text-center mb-16" data-id="element-283">
          <h2 id="who-we-serve-heading" className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-284">
            Who We Serve
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-285"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-286">
          {columns.map((column, colIndex) => <motion.div key={colIndex} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: colIndex * 0.2
        }} className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10" data-id="element-287">
              <ul className="space-y-4" role="list" data-id="element-288">
                {column.map((item, itemIndex) => <li key={itemIndex} className="flex items-center text-white/90" data-id="element-289">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#4AA6CF] mr-3 flex-shrink-0" aria-hidden="true" data-id="element-290"></span>
                    <span className="font-medium" data-id="element-291">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}